import { IconButton } from '@mui/material';
import React, { ReactNode, useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Row } from 'saladsoft-primitive';
import styled from 'styled-components';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import Text from 'components/commons/Text';
import useToken from 'hooks/useToken';
import { toast } from 'react-toastify';
import KingBedOutlinedIcon from '@mui/icons-material/KingBedOutlined';
import ServiceHelper from 'stores/ServiceHelper';
const ManagementLayout = ({ children }: { children: ReactNode }) => {
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [isContextActive, setIsContextActive] = useState(false);
  const { getUserInfo } = useToken();
  const navigate = useNavigate();
  const location = useLocation();

  const routes = [
    {
      route: '/management/reservations',
      name: '예약관리',
      submenus: [
        { route: '/management/reservations/daily', name: '일별 예약' },
        { route: '/management/reservations/period', name: '기간별 예약' },
      ],
    },
    {
      route: '/management/vouchers',
      name: '바우처',
      submenus: [
        { route: '/management/vouchers/categories', name: '바우처 카테고리' },
        { route: '/management/vouchers/list', name: '바우처 목록' },
      ],
    },
    {
      route: '/management/coupons',
      name: '쿠폰',
      submenus: [
        { route: '/management/coupons', name: '쿠폰카테고리' },
        { route: '/management/coupons/users', name: '쿠폰목록' },
      ],
    },
    { route: '/management/messages', name: '메시지(예정)' },
    {
      route: '/management/users',
      name: '회원관리',
      submenus: [
        { route: '/management/users/normal', name: '일반 회원 목록' },
        { route: '/management/users/managers', name: '관리자 목록' },
      ],
    },
  ];

  const checkAdminRole = async () => {
    const roleType = await ServiceHelper.myAccountService?.getMyAccount();
    if (roleType?.data?.roleType !== 'ADMIN') {
      navigate('/admin/listings');
      return;
    }
  };

  checkAdminRole();

  // 라우트 변경 감지하여 메뉴 숨기기
  useEffect(() => {
    setActiveMenu(null);
  }, [location]);

  // 바닥 클릭 시 메뉴 숨기기
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      // 메뉴 아이템이나 서브메뉴를 클릭한 경우는 무시
      if (target.closest('.menu-item') || target.closest('.submenu-container')) {
        return;
      }
      setActiveMenu(null);
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleMenuClick = (route: string, e: React.MouseEvent) => {
    e.stopPropagation(); // 이벤트 버블링 방지
    setActiveMenu(activeMenu === route ? null : route);
  };

  const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    toast.success('로그아웃 되었습니다.');
    navigate('/login');
  };

  return (
    <Container
      onClick={(e) => {
        const target = e.target as HTMLElement;
        // 메뉴 영역이나 서브메뉴 영역을 클릭한 경우는 무시
        if (target.closest('.menu-item') || target.closest('.submenu-container')) {
          return;
        }
        setIsContextActive(false);
      }}
    >
      <Row
        gap="30px"
        height="60px"
        justifyContent="space-between"
        width={'100%'}
        position="sticky"
        top={0}
        background={'#FBFBFB'}
        zIndex={10}
        borderBottom={'1px solid #E0E0E0'}
      >
        <div
          style={{ paddingLeft: 15, cursor: 'pointer' }}
          onClick={() => navigate('/management/reservations/daily')}
        >
          <img src="/images/butlerleelogo.png" alt="butlerlee" style={{ width: '150px' }} />
        </div>
        <Row gap="20px" flexGrow={1}>
          <>
            {routes.map((route) => (
              <ButtonStyle
                $isActive={location.pathname.includes(route.route)}
                className="menu-item"
                onClick={(e) => e.stopPropagation()} // 메뉴 영역 클릭 시 이벤트 전파 중단
              >
                <div onClick={(e) => handleMenuClick(route.route, e)} style={{ cursor: 'pointer' }}>
                  {route.submenus ? (
                    <span>{route.name}</span>
                  ) : (
                    <Link
                      to={route.route}
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(route.route);
                      }}
                    >
                      {route.name}
                    </Link>
                  )}
                </div>
                {activeMenu === route.route && route.submenus && (
                  <div
                    className="submenu-container"
                    style={{
                      position: 'absolute',
                      top: '100%',
                      fontWeight: '600',
                      left: -20,
                      backgroundColor: 'white',
                      boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                      padding: '10px',
                      zIndex: 3000,
                      minWidth: '150px',
                    }}
                  >
                    {route.submenus.map((submenu) => (
                      <LinkWrapper key={submenu.route} style={{ textAlign: 'left' }}>
                        <Link
                          style={{
                            color: '#000',
                            fontSize: 14,
                            fontWeight: 400,
                            padding: '5px 10px',
                          }}
                          to={submenu.route}
                        >
                          {submenu.name}
                        </Link>
                      </LinkWrapper>
                    ))}
                  </div>
                )}
              </ButtonStyle>
            ))}
          </>
          <ButtonStyle>
            <Link
              style={{
                background: 'var(--point-color)',
                color: '#fff',
                padding: '5px 20px',
                borderRadius: 10,
                fontWeight: 600,
                fontSize: 14,
                display: 'flex',
                alignItems: 'center',
                gap: 5,
              }}
              to="/admin/listings"
            >
              <KingBedOutlinedIcon style={{ fontSize: 17 }} />
              {/* <AirplanemodeActiveOutlinedIcon style={{ fontSize: 17 }} /> */}
              <span>시설관리</span>
            </Link>
          </ButtonStyle>
        </Row>
        <Row gap="5px" paddingRight="30px" justifyContent="flex-start">
          <IconButton style={{ background: '#fff' }} onClick={(e) => e.stopPropagation()}>
            <PermIdentityIcon />
          </IconButton>
          <div
            style={{ textAlign: 'left', position: 'relative', cursor: 'pointer' }}
            onClick={(e) => {
              e.stopPropagation(); // 클릭 이벤트 전파 방지
              setIsContextActive(!isContextActive);
            }}
          >
            <Text type="H4" style={{ fontWeight: 600 }}>
              {getUserInfo()}
            </Text>
            <ContextWrapper $isActive={isContextActive} onClick={(e) => e.stopPropagation()}>
              <div
                onClick={() => {
                  logout();
                }}
              >
                <Text type="H4" style={{ fontWeight: 600 }}>
                  Logout
                </Text>
              </div>
            </ContextWrapper>
          </div>
        </Row>
      </Row>
      <Row
        width="100%"
        flexGrow={1}
        alignItems="flex-start"
        justifyContent="flex-start"
        boxSizing="border-box"
        padding={
          location.pathname !== '/admin/listings' &&
          !location.pathname.includes('/management/reservations')
            ? '0 20px'
            : '0'
        }
      >
        <div style={{ position: 'sticky', top: 60, left: 0 }}></div>
        <div style={{ flexGrow: 1, width: '100%' }}>{children}</div>
        {/* <div style={{ flexGrow: 1 }}>{children}</div> */}
      </Row>
    </Container>
  );
};

const Container = styled.div``;

const ButtonStyle = styled.div<{ $isActive?: boolean }>`
  min-width: 100px;
  text-align: center;
  a {
    font-weight: ${({ $isActive }) => ($isActive ? '700' : '400')};
    text-decoration: none;
    color: inherit;
  }
  font-weight: ${({ $isActive }) => ($isActive ? '700' : '400')};
  padding-bottom: 16px;
  color: ${({ $isActive }) => ($isActive ? 'var(--point-color)' : 'inherit')};
  position: relative;
  top: 10px;
  border-bottom: 2px solid ${({ $isActive }) => ($isActive ? 'var(--point-color)' : 'transparent')};
`;

const ContextWrapper = styled.div<{ $isActive?: boolean }>`
  position: absolute;
  top: 50px;
  left: -30px;
  width: 100%;
  background: #fff;
  border-radius: 5px;
  padding: 20px;
  min-width: 200px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  display: ${({ $isActive }) => ($isActive ? 'block' : 'none')};
  pointer-events: ${({ $isActive }) => ($isActive ? 'auto' : 'none')};
  &:hover {
    background: #f0f0f0;
  }
`;

const LinkWrapper = styled.div`
  padding: 10px;
  &:hover {
    background: #f0f0f0;
  }
`;

export default ManagementLayout;
